import { ThemeUICSSObject } from 'theme-ui';

export const markdown: ThemeUICSSObject = {
  padding: '0 24px 32px 24px',
  'h1, h2, h3, h4, h5, h6': {
    margin: '32px 0px 20px 0px',
    '& *': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontFamily: 'inherit',
    },
  },

  blockquote: {
    fontStyle: 'italic',
  },

  table: {
    variant: 'layout.common.tables.secondary',
    thead: {
      zIndex: 0,
    },
  },

  '.markdownResizableTable': {
    minWidth: '100%',
  },

  '.markdownResizableTable th': {
    position: 'relative',
  },

  '.markdownTableResizeHandle': {
    bottom: 0,
    cursor: 'col-resize',
    position: 'absolute',
    right: '-3px',
    top: 0,
    touchAction: 'none',
    userSelect: 'none',
    width: '6px',
    zIndex: 1,
  },

  '.markdownTableResizeHandle:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },

  h2: {
    display: 'block',
    borderBottom: '2px solid hsl(195deg 10% 49% / 50%)',
    paddingBottom: '16px',
  },

  h3: {
    textDecoration: 'underline',
  },

  h4: {
    fontSize: '20px',
  },

  ul: {
    listStyle: 'unset',
    listStyleType: 'disc',
    margin: 'unset',
    padding: 'unset',

    paddingLeft: '20px',
    paddingBottom: '16px',
  },
  'ol + ul, ul + ul, ol ul, ul ul': {
    paddingLeft: '72px',
  },
  'p, ul, ol, blockQuote, table': {
    mt: '16px',
  },
};
